<div class="m-l-10">
  <p class="h4"
    [tradeClass]="'!col-11 col-12'"
    *iCms="'heading' of column">
  </p>
  <ul class="w-12">
    @for (item of column.links; track $index; let isFirst = $first) {
      <li class="p1 m-t-2 link-item"
        [tradeClass]="'!col-12 col-w'">
        <href [link]="item.link">
            <span   *iCms="'label' of item"></span>
        </href>
      </li>
    }
  </ul>
</div>
